const React = require('react');
const PropTypes = require('prop-types');

require('./GlossarySearchResult.scss');

const GlossarySearchResult = ({ onClick, result }) => (
    <button
        className="results--item"
        onClick={onClick}
    >
        {result}
    </button>
);

GlossarySearchResult.propTypes = {
    onClick: PropTypes.func,
    result: PropTypes.string.isRequired,
};

module.exports = GlossarySearchResult;
